export default __webpack_public_path__ + "static/media/b55.7702f726.png";